// Schémas pédagogiques inline (SVG) : probabilités, marge, combiné.
export function MarginDiagram() {
  const parts = [
    { label: "Victoire A — 47,6 %", w: 44.4, color: "#2BB08A" },
    { label: "Nul — 30,3 %", w: 28.2, color: "#0B1F3A" },
    { label: "Victoire B — 29,4 %", w: 27.4, color: "#94A3B8" },
  ];
  let x = 0;
  return (
    <figure
      data-testid="diagram-margin"
      className="my-8 rounded-xl border border-slate-200 bg-white p-6"
    >
      <figcaption className="mb-4 font-display text-sm font-semibold text-[#0B1F3A]">
        La somme des probabilités implicites dépasse 100 % : c'est la marge de l'opérateur.
      </figcaption>
      <svg viewBox="0 0 100 18" className="w-full" role="img"
        aria-label="Barre montrant trois probabilités implicites totalisant 107,3 pour cent">
        {parts.map((p) => {
          const el = (
            <rect key={p.label} x={x} y="4" width={p.w} height="10" fill={p.color} rx="0.8" />
          );
          x += p.w;
          return el;
        })}
        <line x1="93.1" y1="1" x2="93.1" y2="17" stroke="#E8A317" strokeWidth="0.6" strokeDasharray="1.2 1" />
        <text x="93.1" y="0.5" fontSize="3" fill="#78350F" textAnchor="middle" fontWeight="600">
          100 %
        </text>
      </svg>
      <div className="mt-3 flex flex-wrap gap-4 text-xs text-slate-600">
        {parts.map((p) => (
          <span key={p.label} className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-sm" style={{ background: p.color }} />
            {p.label}
          </span>
        ))}
        <span className="flex items-center gap-1.5 font-semibold text-[#78350F]">
          <span className="h-2.5 w-2.5 rounded-sm bg-[#E8A317]" />
          Excédent : 7,3 points = marge
        </span>
      </div>
    </figure>
  );
}

export function OddsLadderDiagram() {
  const rows = [
    ["1,25", 80], ["1,50", 66.7], ["2,00", 50], ["3,00", 33.3], ["5,00", 20], ["10,00", 10],
  ];
  return (
    <figure
      data-testid="diagram-odds-ladder"
      className="my-8 rounded-xl border border-slate-200 bg-white p-6"
    >
      <figcaption className="mb-4 font-display text-sm font-semibold text-[#0B1F3A]">
        Plus la cote est basse, plus l'événement est jugé probable (probabilité implicite = 1 ÷ cote).
      </figcaption>
      <div className="space-y-2">
        {rows.map(([cote, p]) => (
          <div key={cote} className="flex items-center gap-3">
            <span className="w-14 shrink-0 text-right font-display text-sm font-semibold text-[#0B1F3A]">
              {cote}
            </span>
            <div className="h-5 flex-1 rounded bg-[#F3F5F8]">
              <div
                className="h-5 rounded bg-[#2BB08A]"
                style={{ width: `${p}%`, opacity: 0.45 + (p / 100) * 0.55 }}
              />
            </div>
            <span className="w-14 shrink-0 text-sm text-slate-600">
              {String(p).replace(".", ",")} %
            </span>
          </div>
        ))}
      </div>
    </figure>
  );
}

export function CombiDiagram() {
  return (
    <figure
      data-testid="diagram-combi"
      className="my-8 rounded-xl border border-slate-200 bg-white p-6"
    >
      <figcaption className="mb-4 font-display text-sm font-semibold text-[#0B1F3A]">
        Dans un combiné, les cotes se multiplient — et la probabilité de gagner chute.
      </figcaption>
      <svg viewBox="0 0 320 70" className="w-full max-w-xl" role="img"
        aria-label="Trois cotes 1,80, 2,10 et 1,50 multipliées donnent une cote totale de 5,67">
        <g fontFamily="Poppins, sans-serif" fontWeight="600" textAnchor="middle">
          <rect x="4" y="14" width="76" height="40" rx="8" fill="#F3F5F8" stroke="#CBD5E1" />
          <text x="42" y="39" fontSize="15" fill="#0B1F3A">1,80</text>
          <text x="92" y="40" fontSize="16" fill="#94A3B8">×</text>
          <rect x="104" y="14" width="76" height="40" rx="8" fill="#F3F5F8" stroke="#CBD5E1" />
          <text x="142" y="39" fontSize="15" fill="#0B1F3A">2,10</text>
          <text x="192" y="40" fontSize="16" fill="#94A3B8">×</text>
          <rect x="204" y="14" width="76" height="40" rx="8" fill="#F3F5F8" stroke="#CBD5E1" />
          <text x="242" y="39" fontSize="15" fill="#0B1F3A">1,50</text>
          <text x="292" y="40" fontSize="16" fill="#94A3B8">=</text>
        </g>
      </svg>
      <p className="mt-3 text-sm text-slate-600">
        Cote totale <strong>5,67</strong> → probabilité implicite globale :{" "}
        <strong>17,6 %</strong> seulement.
      </p>
    </figure>
  );
}
